import { BusinessContext } from "@/features/business/contexts//BusinessContext";
import { useContext } from "react";

export function useCurrentBusiness() {
  const context = useContext(BusinessContext);
  if (context === undefined) {
    throw new Error("useBusiness must be used within a BusinessProvider");
  }
  return context;
}
